/**
 * Runs code after the onNuxtReady event
 * @param callback The function to call
 * NOTE: This used to have a debounce, but I don't know why that would be needed.  Nuxt Ready implies that this code is ran when nuxt is spun up, hence once.
 */
export default function (callback: () => void) {
  onNuxtReady(callback)
}
